// src/packages/draggable/index.js
import Vue from 'vue'
import draggable from 'vuedraggable'
Vue.component('Draggable', draggable)
